import React, {useEffect, useState} from 'react';
import SocietyInformationAudit from './SocietyInformationAudit';
import DataCount from './DataCount';
import '../../../components/sandbox/index.css';

const HomeComponent = () => {
	const [divIndex, setDivIndex] = useState(0);

	useEffect(() => {
		let index = 0;
		const interval = setInterval(() => {
			setDivIndex(index);
			index++;
			if (index >= 2) clearInterval(interval);
		}, 300);
		return () => clearInterval(interval);
	}, []);

	return (
		<>
			<div className="panel panel-default mt-20">
				<p style={{fontWeight: 'bold', marginLeft: 20, fontSize: 20}}>社科联统计信息</p>
			</div>
			<div className="panel panel-default mt-20">
				<div className="panel-header">数据统计</div>
				<DataCount/>
			</div>
			<div className="panel panel-default mt-20">
				<div className="panel-header">近1年需换届社会组织</div>
				<SocietyInformationAudit/>
			</div>
		</>
	);
};

export default HomeComponent;
